export default "__VITE_ASSET__ce63768f__"